import React from 'react';
import { Chip } from '@mui/material';
import { InstallmentStatus, LoanStatus, LoanType } from '../../interfaces/employeeLoan.interface';
import { humanizeEnum } from '../../utils/format';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const loanPeriod = (year: number, month: number): string => `${MONTHS[month - 1] ?? month} ${year}`;

/** Short visible loan number, same format as the disbursement batch files: LN-<first 8 of the id>. */
export const loanRef = (id: string): string => `LN-${id.replace(/-/g, '').slice(0, 8)}`;

export const loanTypeLabel = (t: LoanType): string => (t === 'SALARY_ADVANCE' ? 'Salary advance' : 'Loan');

const STATUS_COLOR: Record<LoanStatus, 'default' | 'info' | 'warning' | 'success' | 'error'> = {
    REQUESTED: 'warning',
    APPROVED: 'info',
    ACTIVE: 'success',
    CLOSED: 'default',
    REJECTED: 'error',
    CANCELLED: 'default',
    WRITTEN_OFF: 'error',
};

export const LoanStatusChip: React.FC<{ status: LoanStatus }> = ({ status }) => (
    <Chip size="small" color={STATUS_COLOR[status] ?? 'default'} label={humanizeEnum(status)} />
);

const INSTALLMENT_COLOR: Record<InstallmentStatus, 'default' | 'info' | 'warning' | 'success' | 'error'> = {
    SCHEDULED: 'default',
    ATTACHED: 'info',
    DEDUCTED: 'success',
    DEDUCTED_UNPOSTED: 'warning',
    HELD: 'warning',
    WAIVED: 'default',
};

const INSTALLMENT_LABEL: Record<InstallmentStatus, string> = {
    SCHEDULED: 'Scheduled',
    ATTACHED: 'In payroll run',
    DEDUCTED: 'Deducted',
    DEDUCTED_UNPOSTED: 'Deducted (journal pending)',
    HELD: 'Held',
    WAIVED: 'Waived',
};

export const InstallmentStatusChip: React.FC<{ status: InstallmentStatus }> = ({ status }) => (
    <Chip size="small" color={INSTALLMENT_COLOR[status] ?? 'default'} label={INSTALLMENT_LABEL[status] ?? humanizeEnum(status)} />
);
